var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hint"},[(_vm.getStoreHiddenParameter.isRecording)?_c('sound-wave-anim'):_c('img',{attrs:{"alt":"","src":require("@/assets/soundwave.svg")}}),_c('h3',[_vm._v(" "+_vm._s(_vm.question)+" "),_c('span',[_vm._v(_vm._s(_vm.answer))])]),_c('h4',[_vm._v(" "+_vm._s(_vm.hint))]),_c('div',{staticClass:"clear"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }